import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ideal-product-listing-layout',
  standalone: true,
  imports: [],
  templateUrl: './product-listing-layout.component.html',
  styleUrl: './product-listing-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.float-header]': 'floatHeader()',
  },
})
export class ProductListingLayoutComponent {
  readonly floatHeader = input(false);
}
